enum LiabilityFinancingTypeEnum {
    CONSOLIDATION = 'CONSOLIDATION',
}

export default LiabilityFinancingTypeEnum;
